import MobileTermsAndConditions from '@map/components/MobileTermsAndConditions/MobileTermsAndConditions';
import { ComponentProps, useCallback, useMemo, useState } from 'react';

type Tab = ComponentProps<typeof MobileTermsAndConditions>['tab'];

export default function useTermsAndConditions() {
  const [tab, setTab] = useState<Tab | null>(null);

  const show = (tab: Tab = 'termsOfUse') => {
    setTab(tab);
  };
  const hide = useCallback(() => setTab(null), [setTab]);

  const node = useMemo(
    () => (tab ? <MobileTermsAndConditions tab={tab} onClose={hide} onChangeTab={setTab} /> : null),
    [setTab, tab, hide],
  );
  return [show, node] as const;
}
